import API from "../API/API";

// 상세정보 호출API
const getDetailList = async (reNum: string) => {
  const response: any = await API.get(`/receipt/detail/${reNum}`);
  if (response.status === 200) {
    return response;
  } else {
    alert("Fail to getDetailList()");
  }
};

// 계약서번호(reNum)을 보내면, 해당 계약서 이미지 리스트를 반환합니다.
const getContractImageList = async (reNum: string) => {
  try {
    const response = await API.get(`/receipt/contract-image/${reNum}`);
    if (response.status === 200) {
      const contractImageList = response.data.contractImageList;
      return contractImageList;
    } else {
      throw new Error("getContractImageList() 실패");
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export { getContractImageList, getDetailList };
